export default class FileUpload {
  constructor(container, options) {
    this.container = container;
    this.options = {
      input: '.js-file-upload-input',
      preview: '.js-file-upload-preview',
      label: '.js-file-upload-label',
      deleteButton: '.js-file-upload-delete',
      changeButton: '.js-file-upload-change',
      ...options,
    };
    this.initLabel = null;
  }

  init() {
    this.addEvents();
  }

  addEvents() {
    const inputRoot = this.container.querySelector(this.options.input);
    const changeButton = this.container.querySelector(this.options.changeButton);
    const deleteButton = this.container.querySelector(this.options.deleteButton);
    const label = this.container.querySelector(this.options.label);

    if (label) {
      this.initLabel = label.innerText;
    }

    if (inputRoot && inputRoot.querySelector('input')) {
      const input = inputRoot.querySelector('input');
      input.addEventListener('input', (event) => this.handleChange(event));

      if (changeButton) {
        changeButton.addEventListener('click', () => {
          input.click();
        });
      }

      if (deleteButton) {
        deleteButton.addEventListener('click', () => {
          this.handleRemove(input);
        });
      }
    }
  }

  handleChange(event) {
    if (event.target.files.length > 0) {
      this.setLabel(event.target.files[0].name);
    }
  }

  handleRemove(input) {
    const inputEl = input;

    inputEl.value = '';
    this.setLabel('');
  }

  setLabel(value) {
    const label = this.container.querySelector(this.options.label);

    if (label && value === '') {
      label.innerText = this.initLabel;
    } else {
      label.innerText = value;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const fileUploads = Array.from(document.querySelectorAll('.js-file-upload'));
  fileUploads.forEach((container) => {
    const fileUpload = new FileUpload(container);
    fileUpload.init();
  });
});
